import { render, staticRenderFns } from "./PageParams.vue?vue&type=template&id=21db83dc&scoped=true"
import script from "./PageParams.vue?vue&type=script&lang=js"
export * from "./PageParams.vue?vue&type=script&lang=js"
import style0 from "./PageParams.vue?vue&type=style&index=0&id=21db83dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21db83dc",
  null
  
)

export default component.exports